export default __webpack_public_path__ + "static/about_company_2-b7cc8be31c7bd81cd005650ea7c8af73.png";